
/**
 * Generates a unique campaign ID with CPN prefix
 * @returns A string with format CPN-XXXXXXXX where X is an alphanumeric character
 */
export const generateCampaignId = (): string => {
  // Current timestamp in milliseconds
  const timestamp = Date.now().toString(36);
  
  // Random component to ensure uniqueness
  const randomStr = Math.random().toString(36).substring(2, 6);
  
  // Combine with CPN prefix and format
  return `CPN-${timestamp.substring(timestamp.length - 4)}${randomStr}`.toUpperCase();
};

/**
 * Checks if a campaign ID is valid (has CPN prefix and correct format)
 * @param id The campaign ID to validate
 * @returns Boolean indicating if ID is valid
 */
export const isValidCampaignId = (id: string): boolean => {
  return /^CPN-[A-Z0-9]{8}$/.test(id);
};

/**
 * Extracts campaign numerical identifier from full campaign ID
 * @param globalId The full campaign ID with CPN prefix
 * @returns The numerical identifier portion
 */
export const extractCampaignIdNumber = (globalId: string): string => {
  if (!isValidCampaignId(globalId)) return '';
  return globalId.substring(4); // Remove CPN- prefix
};
